import { buildProxyConfigShape, } from '../base.js';
import { managementAppProxyApi } from './management-app.js';
import { mslMcpProxyApi } from './msl-mcp.js';
export * from './management-app.js';
export * from './msl-mcp.js';
const customPageProxyApisInternal = [
    managementAppProxyApi,
    mslMcpProxyApi,
];
export const customPageProxyApis = customPageProxyApisInternal;
export const customPageProxyConfigShape = buildProxyConfigShape(customPageProxyApisInternal);
